import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/icons/ArrowRight.svg";
import {
    StyledInformationContainer,
    StyledInfoTextContainer,
    StyledPeriodInfo,
    StyledTeacherInfo,
} from "../../../../styles/pages/Workflows/InformationTach";
import StringUtils from "../../../../utils/types/StringUtils";
import WorkflowService from "../../../../service/Docente/WorkflowService";
import GenericUtils from "../../../../utils/GenericUtils";
import ModalAlertTach from "../ModalAlertTach";

type Information = {
    workflow: any;
    viewButton: (url: string) => void;
};

const InformationTach = ({ workflow, viewButton }: Information) => {
    const { instance } = useMsal();
    const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
    const formatDate = "dd/MM/yyyy";

    const handleCloseAlertModal = () => {
        setShowAlertModal(false);
    };

    const alertModal = (
        <ModalAlertTach open={showAlertModal} onClose={handleCloseAlertModal} />
    );

    const getUrlPdf = async () => {
        const response = await WorkflowService.getDocTachById(
            instance,
            workflow.workflowProcessoId
        );

        if (GenericUtils.isSuccessStatus(response)) {
            viewButton(response.data.url);
        } else {
            setShowAlertModal(true);
        }
    };

    const getTeacherName = (fullName: string): string => {
        const name = fullName.split(" ");
        return `${name[0]} ${name[name.length - 1]} - ${
            workflow.docente.matriculaAdp
        }`;
    };

    return (
        <StyledInformationContainer>
            <StyledInfoTextContainer>
                <StyledTeacherInfo>
                    {getTeacherName(workflow.docente.nome)}
                </StyledTeacherInfo>
                <StyledPeriodInfo>{`Vigência: ${StringUtils.formatDateString(
                    workflow.vigencia.planoAtividadeDtInicio,
                    formatDate
                )} até ${StringUtils.formatDateString(
                    workflow.vigencia.planoAtividadeDtFim,
                    formatDate
                )}`}</StyledPeriodInfo>
            </StyledInfoTextContainer>
            <StyledDefaultButtonLink variant="link" onClick={() => getUrlPdf()}>
                <ArrowRightIcon style={{ fill: "#8A0538" }} />
                Visualizar TACH
            </StyledDefaultButtonLink>
            {showAlertModal && alertModal}
        </StyledInformationContainer>
    );
};

export default InformationTach;
